import { useFormikContext } from 'formik'

import { AccountsList } from './list.component'
import { useScanRelationContext } from '../form-wrapper/relations-context.component'
import {
  ECreateScanMode,
  EScanRecordType,
  IAccountByIdRawRespDto,
  IScanCreateForm,
} from 'src/types'
import { useStyles } from '../styles'

export const AccountStep = () => {
  const classes = useStyles()
  const { setRelations, step, relations, setStep, setCreateScanMode, setFormType } =
    useScanRelationContext()
  const { setFieldValue } = useFormikContext<IScanCreateForm>()

  if (step !== 0) {
    return null
  }

  const handleSelectItem = (item: IAccountByIdRawRespDto) => {
    setRelations((prev) => ({ ...prev, account: item, step: null, product: null, impact: null }))
    setFieldValue('account_id', item.id)
    setFieldValue('step_id', null)
    setFieldValue('product_id', null)
    setFieldValue('impact_id', null)
    setFormType(EScanRecordType.General)
    setCreateScanMode(ECreateScanMode.Default)
    setStep(1)
  }

  return (
    <div className={classes.sectionWrapper}>
      <div className={classes.section}>
        <AccountsList selectedItemData={relations.account} handleItemSelect={handleSelectItem} />
      </div>
    </div>
  )
}
